import moment from "moment";
import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import useSWR from "swr";
import { API } from "../../../StoreComponents/conflict";

const fetcher = (url) => API.get(url).then((res) => res.data.data);
const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);
const LogsProduct = () => {
  const [openElement, setOpenElement] = useState(false);
  const [printButton, setPrintButton] = useState(false);
  const [typeError, setTypeError] = useState("");
  const [selectedProduct, setSelectedProduct] = useState({});
  // get Enties All Product Data
  const {
    data: allEnties,
    error,
    mutate,
  } = useSWR(
    selectedProduct.value
      ? `store/reports/productlogs?queryFor=product&proid=${selectedProduct.value}`
      : null,
    fetcher
  );
  // get UnitData
  const { data: productOption, error: error3 } = useSWR(
    `store/products/storeProducts?page=${0}&limit=${10000}`,
    fetcher1
  );
  console.log(allEnties);
  // handle product select;
  const handleProduct = (product) => {
    setSelectedProduct(product);
  };

  // set Product select list
  let productCategory = [];
  if (productOption && productOption.length > 0) {
    productCategory = productOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.PROID;
      optionsItem.label = `${data.PRONAME} - ${data.PRONAMETWO}`;
      return optionsItem;
    });
  }

  // toggle seach button
  const handleToggle = () => {
    if (!selectedProduct.value) {
      setTypeError("field Required");
      setOpenElement(false);
      setPrintButton(false);
    } else {
      setOpenElement(true);
      setPrintButton(true);
      setTypeError("");
    }
  };

  // print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Helmet>
        <title>All Products - BBA STORE</title>
        <meta name="description" content="Product List - BBA STORE" />
      </Helmet>
      <style type="text/css">{"label{font-size:1rem !important}"}</style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">
              Search Logs By Product Wise
            </h3>
            <button
              onClick={handlePrint}
              type="button"
              className={
                printButton
                  ? "btn btn-color px-3 printBtn show"
                  : "printBtn btn btn-danger px-3"
              }
            >
              <i className="fa fa-print"></i>
              <span> Print</span>
            </button>
          </div>

          {/* Seach Element */}
          <div className="category show">
            <div className="mx-auto">
              <div className="add_category text-center">
                <div className="row mx-3">
                  <div className="col-12 col-md-5 col-lg-5">
                    <label htmlFor="product_name">
                      Product Name <span className="color-red">*</span>
                    </label>
                    <Select
                      onChange={handleProduct}
                      style={{ borderRadius: "10px" }}
                      className="text-start fs-6"
                      options={productCategory}
                    />
                    <p className="text-start text-danger">
                      {selectedProduct.value ? "" : typeError}
                    </p>
                  </div>
                </div>
                <br />
                <button
                  onClick={handleToggle}
                  type="button"
                  className="mt-3 px-5 btn btn-color_store"
                >
                  <i className="fa fa-search"></i>
                  <span> Search</span>
                </button>
              </div>

              {/* Search Result */}
              {allEnties ? (
                <div
                  ref={componentRef}
                  className={
                    openElement
                      ? "category show my-4 table-container p-2"
                      : "category my-4 table-container p-2"
                  }
                  style={{ background: "white", borderRadius: "10px" }}
                >
                  <div className="text-center mt-4 mb-5">
                    <div>
                      <h4>
                        <b>INFOTECH IT SOLUTIONS</b>
                      </h4>
                     
                      <h3>দ্রব্য লগ</h3>
                      <h5>({selectedProduct ? selectedProduct.label : ""})</h5>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped boder">
                      <thead>
                        <tr className="text-center">
                          <th className=" col-design1" colSpan="1">
                            S/N
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Date
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Initial
                          </th>
                          <th className=" col-design1" colSpan="1">
                            New Add
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Total
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Out
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Balance
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Out To
                          </th>
                        </tr>
                      </thead>
                      {allEnties.productSummaries && (
                        <tbody>
                          {allEnties.productSummaries.map((product, index) => (
                            <tr key={index}>
                              <th className=" col-design1">{index + 1}</th>
                              <td className=" col-design1">
                                {moment(new Date(product.SUMMDATE)).format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                              <td className=" col-design1">
                                {product.INTIALQTY}
                              </td>
                              <td className=" col-design1">
                                {product.NEWADDQTY ? product.NEWADDQTY : 0}
                              </td>
                              <td className=" col-design1">
                                {product.TOTALBALANCE}
                              </td>
                              <td className=" col-design1">
                                {product.TOTALOUT ? product.TOTALOUT : 0}
                              </td>
                              <td className=" col-design1">
                                {product.PRESENTBALANCE}
                              </td>
                              <td className=" col-design1">
                                {product.NAME} <br /> {product.DESIGNATION}
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <th className=" col-design1"></th>
                            <td className=" col-design1"></td>
                            <td className="fw-bold col-design1">
                              Grand Total IN
                            </td>
                            <td className=" col-design1">
                              {allEnties.totalIn}
                            </td>
                            <td className="fw-bold col-design1">
                              Grand Total OUT
                            </td>
                            <td className="fw-bold col-design1">
                              {allEnties.totalOut}
                            </td>
                            <td className=" col-design1"></td>
                            <td className=" col-design1"></td>
                          </tr>
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          {/* Seach Element */}
        </div>
      </div>
    </>
  );
};

export default LogsProduct;
